import type { Markings } from 'chessboard/plugins/markings/config/types';
import type JCE from '@chesscom/js-chess-engine';
import { convertMarkingFromJCE } from 'chessboard/plugins/markings/model/convert-marking-from-jce';

/**
 * Get JCE markings as a flat array. JCE markings are provided as a nested object,
 * which needs to be flattened twice to get a flat array of individual markings.
 *
 *  game.markings() {
 *    square: {
 *       d4: { key: 'd4', data: [], type: 'square' },
 *    },
 *    arrow: {
 *      d4d5: { key: 'd4d5', data: [], type: 'arrow' },
 *    },
 *  }
 *
 *  must be flattened twice to get:
 *
 * [
 *   { key: 'd4', data: [], type: 'square' },
 *   { key: 'd4d5', data: [], type: 'arrow' },
 * ]
 */
export function getMarkingsFromJCE(game: JCE.Game, markings?: JCE.Markings): Markings.KeyedModel[] {
  const converted: Markings.KeyedModel[] = [];
  const jceMarkings = markings ?? game.markings();

  Object.values(jceMarkings).forEach((withKeys: JCE.Marking.Collection) => {
    Object.values(withKeys).forEach((marking) => {
      converted.push(convertMarkingFromJCE(marking));
    });
  });

  return converted;
}
